import {CodeName} from "../../stocks/models/code-name";
import {TranslateService} from '@ngx-translate/core';

export class DialogOptions{
    constructor(){
        this.init()
    }
    public okTxt: string;
    public yesTxt: string;
    public noTxt: string;
    public cancelTxt: string;
    public okTitle: string;
    public yesTitle: string;
    public noTitle: string;
    public cancelTitle: string;
    public okOrder: number;
    public yesOrder: number;
    public noOrder: number;
    public cancelOrder: number;

    public init = (): void => {
        this.okTxt = 'Ok';
        this.yesTxt = 'Yes';
        this.noTxt = 'No';
        this.cancelTxt = 'Cancel';
        this.okTitle = '';
        this.yesTitle = '';
        this.noTitle = '';
        this.cancelTitle = '';
        this.okOrder = 0;
        this.yesOrder = 0;
        this.noOrder = 0;
        this.cancelOrder = 0;
    }

    public consumeOptions = (options: DialogOptions): void => {
        this.okTxt = options.okTxt;
        this.yesTxt = options.yesTxt;
        this.noTxt = options.noTxt;
        this.cancelTxt = options.cancelTxt;
        this.okTitle = options.okTitle;
        this.yesTitle = options.yesTitle;
        this.noTitle = options.noTitle;
        this.cancelTitle = options.cancelTitle;
        this.okOrder = options.okOrder;
        this.yesOrder = options.yesOrder;
        this.noOrder = options.noOrder;
        this.cancelOrder = options.cancelOrder;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/dialogOptions.ts